import { BaseModal } from './EditProfileRoute';
import { UserDataForm } from '../../../components/forms/UserDataForm';
import { useCustomerContext } from '../../../components/CustomerProvider.tsx';

export function EditNameRoute() {
    const { user, refetchUser } = useCustomerContext();
    return (
        <BaseModal
            open={true}
            user={user}
            refetchUser={refetchUser}
            render={control => <UserDataForm.NameField control={control} />}
        />
    );
}
